// CacheKey 493ae0ad6f73d4157da1423ac2793eb6
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-JACK_HUGHSTON": {
    filters: {
      arrival: {
        label: "Appointment",
        title: "Filter by appointment date"
      }
    }
  }
}

